// Delivery windows are stored to the whole minute. Integrations that hold a window to the minute
// (Xcelerator Axis) read a window with seconds back seconds off, and that registers as a reschedule.
// Empty values pass through so callers can clear a window.
export const toMinuteIso = (value) => {
    if (!value) return value;
    const date = new Date(value);
    date.setUTCSeconds(0, 0);
    return date.toISOString();
};
